import About from "../pages/about";
import Video from "../pages/video";
import Benefits from "../pages/benefits";
import Features from "../pages/features";
import CustomerStories from "../pages/customer-stories";
import Hero from "../pages/hero";
import "./main.scss";
import { Dispatch, SetStateAction } from "react";

const Main = ({
  setInquiryPopup,
  setBrochurePopup,
}: {
  setInquiryPopup: Dispatch<SetStateAction<boolean>>;
  setBrochurePopup: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <main className="Main">
      <Hero
        setInquiryPopup={setInquiryPopup}
        setBrochurePopup={setBrochurePopup}
      />
      <About />
      <Video />
      <Benefits />
      <Features />
      <CustomerStories setInquiryPopup={setInquiryPopup} />
    </main>
  );
};

export default Main;
